<match-wrapper
    label="{{ label }}"
    objectType="{{ objectType }}"
    fieldName="{{ fieldName }}"
    (onRemoveMatch)="removeMatch()"
>
    <div
        class="geo-match"
        provideParentForm
    >
        <label
            aviLabelWithTooltip
            objectType="{{ matchObjectType }}"
            fieldName="attribute"
            for="{{ 'attribute-' + matchIndex }}"
            required
        >
            {{ l10nKeys.attributeLabel | vtranslate }}
        </label>
        <avi-enum-dropdown
            name="{{ 'attribute-' + matchIndex }}"
            [(ngModel)]="editable.config.attribute"
            enum="GeoMappingAttribute"
            placeholder="{{ l10nKeys.attributePlaceholder | vtranslate }}"
            required
        ></avi-enum-dropdown>
        <enum-radio-buttons
            enum="MatchOperation"
            name="match-operation-{{ matchIndex }}"
            [(ngModel)]="editable.config.match_operation"
        ></enum-radio-buttons>
        <div class="geo-match__values-container">
            <avi-input-container>
                <label
                    aviLabelWithTooltip
                    objectType="{{ matchObjectType }}"
                    fieldName="values"
                    for="{{ 'geo-match-values-' + matchIndex }}"
                    required
                >
                    {{ l10nKeys.valuesMatchLabel | vtranslate }}
                </label>
                <avi-repeated-strings
                    id="{{ 'geo-match-values-' + matchIndex }}"
                    name="{{ 'geo-match-values-' + matchIndex }}"
                    placeholder="{{ l10nKeys.valuesMatchInputPlaceholder | vtranslate }}"
                    objectType="{{ matchObjectType }}"
                    fieldName="values"
                    [(ngModel)]="editable.config.values"
                    required
                ></avi-repeated-strings>
            </avi-input-container>
        </div>
    </div>
</match-wrapper>
